import { Flex } from 'antd';
import styled from 'styled-components';

export const StyledFlex = styled(Flex)`
    margin: auto;
`;

export const StyledWrapper = styled.div`
    height: 300px;
    min-height: 300px;
    max-height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;
